import { CSS as CheckBoxCSS } from '../../components/input/input.checkbox';
import { DefaultTheme } from '../../components/theme';
import { CSS as TagCardCheckBoxCSS } from '../tag.card.checkbox/tag.card.checkbox.style';

export const CSS = {
	container: 'c-CollectionCard',
	containerLeft: 'c-CollectionCard__left',
	noLocation: 'c-CollectionCard--no-loc',
	link: 'c-CollectionCard__link',
	info: 'c-CollectionCard__info',
	filterMatch: 'c-CollectionCard__match',
	isHovered: 'c-CollectionCard--is-hovered',
	isInspected: 'c-CollectionCard--is-inspected',
	isSubtitle: 'c-CollectionCard__is-subtitle',
};

const CIRCLE_RADIUS = DefaultTheme.spacingFactor * 2;
const CIRCLE_SIZE_PX = CIRCLE_RADIUS * 2 + 'px';

export const Style = {
	[CSS.container]: {
		display: 'flex',
		'align-items': 'center',
		'padding-left': DefaultTheme.space(3),
		cursor: 'pointer',
		'border-left': `${DefaultTheme.space(1)} solid transparent`,
		'&:hover': {
			backgroundColor: DefaultTheme.font.color.divider,
		},
	},
	[CSS.noLocation]: {
		color: DefaultTheme.font.color.disabled,
		cursor: 'default',
	},
	[CSS.link]: {
		flex: '1',
		'padding-left': DefaultTheme.space(3),
		overflow: 'hidden',
		'white-space': 'nowrap',
		'text-overflow': 'ellipsis',
	},
	[CSS.filterMatch]: {
		fontWeight: DefaultTheme.font.weight.bold,
	},
	[CSS.isSubtitle]: {
		color: DefaultTheme.font.color.supporting,
	},
	[CSS.info]: {
		flex: '1',
		color: DefaultTheme.font.color.disabled,
		'font-size': '90%',
		'padding-right': DefaultTheme.space(1),
		overflow: 'hidden',
		'white-space': 'nowrap',
		'text-overflow': 'ellipsis',
		'text-align': 'right',
	},
	[CSS.isHovered]: {
		'background-color': DefaultTheme.font.color.hover,
	},
	[CSS.isInspected]: {
		'background-color': DefaultTheme.background.offWhite,
		'box-shadow': DefaultTheme.shadow.box.dp2,
		'border-color': DefaultTheme.color.accent,
	},
	[`${CSS.container} .${TagCardCheckBoxCSS.container}`]: {
		width: CIRCLE_SIZE_PX,
		height: CIRCLE_SIZE_PX,
	},
	[`${CSS.container} .${CheckBoxCSS.container} i`]: {
		'font-size': CIRCLE_SIZE_PX,
	},
};
